import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-summary-card',
  templateUrl: './summary-card.component.html',
  imports: [TranslocoPipe, NgClass],
})
export class SummaryCardComponent {
  cardColor = input<string>(' border-r-pink-500 ');

  icon = input.required<string>();
  iconColor = input<string>('text-red-500');

  cardTitle = input.required<string>();
  title = input<string>();

  formattedValue = input.required<string>();
  valueClass = input<string>('text-4xl font-bold');
}
